import { readStoredValue, removeStoredValue, writeStoredValue } from './storage';

export type WorkspaceContext = {
  teamId: string;
  teamName: string;
  projectId: string;
  projectName: string;
};

const workspaceContextKey = 'agentteams-workspace-context';

export const getWorkspaceContext = (): WorkspaceContext | null => {
  const raw = readStoredValue(workspaceContextKey);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as Partial<WorkspaceContext>;
    if (
      typeof parsed.teamId !== 'string' ||
      typeof parsed.teamName !== 'string' ||
      typeof parsed.projectId !== 'string' ||
      typeof parsed.projectName !== 'string'
    ) {
      return null;
    }

    return {
      teamId: parsed.teamId,
      teamName: parsed.teamName,
      projectId: parsed.projectId,
      projectName: parsed.projectName,
    };
  } catch {
    return null;
  }
};

export const saveWorkspaceContext = (context: WorkspaceContext) => {
  writeStoredValue(workspaceContextKey, JSON.stringify(context));
};

export const clearWorkspaceContext = () => {
  removeStoredValue(workspaceContextKey);
};
